/**
 * @file Wrapper module to load react voiceAssistantEnrollment component inside angular
 * @author Max van Loosbroek
 */

import angular from 'angular'
import StoreService from '../../../common/redux/store.service'
import VoiceAssistantEnrollment from './VoiceAssistantEnrollment'

export default angular
  .module('components.tb.voiceAssistantEnrollmentReact', ['react'])
  .directive(
    'tbVoiceAssistantEnrollmentReact',
    (reactDirective, StoreService: StoreService) =>
      reactDirective(VoiceAssistantEnrollment, [], {}, { StoreService })
  )
